export default __webpack_public_path__ + "static/media/logo_conservatorio.58577596.jpg";